/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReservationStateEnum {
    Pending = 'PENDING',
    Checkedin = 'CHECKEDIN',
    Checkedout = 'CHECKEDOUT',
    Confirmed = 'CONFIRMED',
    Canceled = 'CANCELED'
}

export function ReservationStateEnumFromJSON(json: any): ReservationStateEnum {
    return ReservationStateEnumFromJSONTyped(json, false);
}

export function ReservationStateEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReservationStateEnum {
    return json as ReservationStateEnum;
}

export function ReservationStateEnumToJSON(value?: ReservationStateEnum | null): any {
    return value as any;
}

